module.exports = __webpack_public_path__ + "img/icon-eye.0699a45a.svg";